import {
  ENewbuildingBrokerCallbackWidgetActionTypes,
  TNewbuildingBrokerCallbackWidgetActions,
} from 'shared/actions/newbuildingBrokerCallbackWidget';
import { IAppState } from 'shared/common/state';

export function newbuildingBrokerCallbackWidgetReducer(
  state: IAppState,
  action: TNewbuildingBrokerCallbackWidgetActions,
): IAppState {
  switch (action.type) {
    case ENewbuildingBrokerCallbackWidgetActionTypes.OpenWidget:
      return {
        ...state,
        newbuildingBrokerCallbackWidget: {
          ...state.newbuildingBrokerCallbackWidget,
          callbackWidgetOpened: true,
          offerInfo: action.payload,
        },
      };
    case ENewbuildingBrokerCallbackWidgetActionTypes.CloseWidget:
      return {
        ...state,
        newbuildingBrokerCallbackWidget: {
          ...state.newbuildingBrokerCallbackWidget,
          callbackWidgetOpened: false,
          offerInfo: null,
        },
      };
    case ENewbuildingBrokerCallbackWidgetActionTypes.SetBookingLoading:
      return {
        ...state,
        newbuildingBrokerCallbackWidget: {
          ...state.newbuildingBrokerCallbackWidget,
          bookingLoading: action.payload,
        },
      };
    case ENewbuildingBrokerCallbackWidgetActionTypes.ToggleBookingExistsModal:
      return {
        ...state,
        newbuildingBrokerCallbackWidget: {
          ...state.newbuildingBrokerCallbackWidget,
          bookingExistsModalOpened: action.payload,
          callbackWidgetOpened: !action.payload && state.newbuildingBrokerCallbackWidget.callbackWidgetOpened,
        },
      };
    default:
      return state;
  }
}
